export class ScanInput {
  public contactId?: number; // creator contact ID
  public file: string; // the Pdf file
  public description: string;
  public serviceProprietaireId: number;
  public barCode: string;
}
